export const formatPKR = (amount) => {
  const n = Number(amount || 0);
  return `₨ ${n.toLocaleString("en-PK")}`;
};
